import { FormattedMessage } from 'react-intl';

import { TFundingRequirementsSteps } from '../../../funding/fundingSteps/orderFundingRequirements';
import { ONBOARDING_PATHS } from '../../constants';
import { CompletedStepItem } from '../onboardingChecks/onboardingStepItem/CompletedStepItem';
import { OnboardingStepItem } from '../onboardingChecks/onboardingStepItem/OnboardingStepItem';

export const CompleteIDCheck = ({
    step
}: {
    step: TFundingRequirementsSteps[0];
}) => {
    if (step.status === 'COMPLETED') {
        return (
            <CompletedStepItem>
                <FormattedMessage
                    id="_.credit_card.onboarding.id_check_title.completed"
                    defaultMessage="ID check"
                />
            </CompletedStepItem>
        );
    }

    return (
        <OnboardingStepItem
            title={
                <FormattedMessage
                    id="_.credit_card.onboarding.id_check_title.required"
                    defaultMessage="Complete your ID check"
                />
            }
            link={ONBOARDING_PATHS.ONBOARDING_ID_CHECK}
        />
    );
};
